<template>
  <div>
    <ListLayout
      :title="`${accountManagerModule.accountManagerPlural}`"
      :tableData="AccountList"
      :tableHeader="tableHeaders"
      :total="totalItems"
      @getList="getAccountManagerList"
      ref="listTable"
    >
      <template #listAction>
        <PrimaryButton
          id="accountManagerAdd"
          @click="$router.push({ path: '/app/admin/account_manager/add' })"
          name="Add Account Manager"
            icon="mdi-plus"
            iconSize="x-large"
        >
        </PrimaryButton>
      </template>
      <template #rightFilterSlot>
        <div class="w-100 d-flex align-center justify-end">
          <RefreshListButton
            id="accountManagerRefreshList"
            :isIcon="false"
            @click="$refs.listTable.searchTriggered()"
          />
        </div>
      </template>
    </ListLayout>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import AccountMangerButton from "@/components/Button/AccountMangerButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { accountManagerModule } from "@/utils/moduleMapping";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";

export default {
  components: {
    AccountMangerButton,
    ListLayout,
    RefreshListButton,
  },
  data() {
    return {
      accountManagerModule,
      totalItems: 0,
      filters: {},
      AccountList: [],
      headerSelected: [
        {
          headerName: "Username",
          field: "username",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "First name",
          field: "first_name",
          sortable: true,
        },

        {
          headerName: "Last name",
          field: "last_name",
          sortable: true,
        },
        {
          headerName: "Email",
          field: "email",
          sortable: true,
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 120,
          maxWidth: 120,
          sortable: false,
          width: 120,
          cellRenderer: "AccountMangerButton",
        },
      ];
    },
  },
  methods: {
    getAccountManagerList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.accountManager
        .getAccountManagerList(params)
        .then((res) => {
          this.AccountList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
